// packages/storefront/src/api/baseUrls.ts
//
// Single source of truth for the embed's outbound API base URLs.
// Auto-selects local vs. production from `window.location.hostname`:
//
//   - the dev machine (`localhost`, `127.0.0.1`, `*.localhost`) → local dev URLs.
//   - anything else                                              → production URLs.
//
// Partner sites embed embed on real domains, so the local
// branch is unambiguously a developer's dev server (per-app
// AGENTS.md confirms there's no scenario where an embed runs on
// localhost in production), and a widget opened on the dev machine
// books on the dev machine only. No env vars by design — embed
// is built once and shipped via Cloudflare Pages, then loaded onto
// arbitrary partner domains, so build-time env injection wouldn't
// give us per-host behaviour anyway.

import { isLocalDevHostname } from '@tourtask/utils/shared/net/isLocalDevHostname';
import { TOURTASK_API_ORIGIN } from '@tourtask/utils/shared/net/tourtaskOrigins';

// Exported so widgets can show a dev-only diagnostic (the API URL they tried)
// when a boot fetch fails — a real partner site never runs on the dev machine, so
// the hint is invisible to visitors and only ever helps a developer who forgot
// to start the local API (`pnpm dev:api`).
export const isLocalDev = typeof window !== 'undefined' && isLocalDevHostname(window.location.hostname);

/**
 * Base URL for the typed v1 API (`apps/api`).
 *
 * Local dev: Next.js runs on port 4000 (see `dev:api` in the root
 * `package.json`). No host alias needed. Production: the origin the pages
 * that load a widget also hint at (`tourtaskOrigins.ts`).
 */
export const apiV1BaseUrl = isLocalDev
  ? 'http://localhost:4000/v1'
  : `${TOURTASK_API_ORIGIN}/v1`;
